import {
  post_request
} from "../axiosFun"

//区域线路列表
export const get_task_list = (params) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      name: params.name,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/task/get_list", params)
};
//车辆列表
export const get_cars_task = (params) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      vin: params.vin,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/car/get_cars_task", params)
};
//修改车辆列表
export const get_cars_task_edit = (params, task_id) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      task_id: task_id,
      vin: params.vin,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/car/get_cars_task_edit", params)
};
//地图列表
export const get_map_task = (params) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      name: params.map_name_cn,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/map/get_map_task", params)
};
//线路列表
export const get_line_task = (params, map_id) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      map_id: map_id,
      name: params.name_cn,
      page_no: params.page,
      page_size: params.limit
    }
  }
  return post_request("/web/line/get_line_task", params)
};
//添加任务
export const get_add_task = (params, start_time, end_time) => {
  params = {
    row: {
      area_id: window.localStorage.getItem("area_id"),
      name: params.name,
      map_id: params.map_id,
      vin: params.vin,
      line_ids: params.line_id,
      water_status:params.water_status,
      clear_status: params.clear_status,
      water_level: params.water_level,
      electricity: params.electricity_level,
      stop_time:params.stop_time,
      start_time: start_time,
      end_time: end_time,
      run_count: params.run_count,
      remark: params.remark || ""
    }
  }
  return post_request("/web/task/add", params)
};
//获取单条任务信息
export const get_one_task = (params) => {
  params = {
    row: {
      task_id: params,
    }
  }
  return post_request("/web/task/get_one", params)
};
//修改任务
export const get_edit_task = (params, start_time, end_time) => {
  params = {
    row: {
      id: params.id,
      name: params.name,
      map_id: params.map_id,
      vin: params.vin,
      line_ids: params.line_id,
      water_status: params.water_status,
      clear_status: params.clear_status,
      water_level: params.water_level,
      electricity: params.electricity_level,
      stop_time:params.stop_time,
      start_time: start_time,
      end_time: end_time,
      run_count: params.run_count,
      remark: params.remark || ""
    }
  }
  return post_request("/web/task/edit_task", params)
};
//修改任务状态
export const get_switch_status = (params, status) => {
  params = {
    row: {
      id: params,
      status: status,
    }
  }
  return post_request("/web/task/switch_status", params)
};
//删除任务
export const get_del_task = (params, status) => {
  params = {
    row: {
      id: params,
    }
  }
  return post_request("/web/task/del_task", params)
};



// WEBPACK FOOTER //
// ./src/api/region/area_task.js